import ChannelCard from "../../Utilities/ChannelCard";
import logoTikTok from "../../../../../images/logos/logo_tiktok_shop.png";
import useTikTokShopSetup from "./useTikTokShopSetup";

export default function TikTokShopProvider(){
    const { initiateTikTokSetup } = useTikTokShopSetup({ callbackPath: '/tiktokshop/accounts' })

    return(
        <ChannelCard
            icon={logoTikTok}
            label={'TikTok Shop'}
            description={'Answer shoppers’ questions while they’re primed to buy on your TikTok Shop'}
            onClick={initiateTikTokSetup}
        />
    )
}